import React from 'react'
import { useRouter } from 'next/router'
import {
  Box,
  Button,
  Typography
} from '@mui/material'
import { format } from 'date-fns'
import { HasEvent } from '@/modules/event/types/event'
import ChronoCard from '@/layouts/core/components/ChronoCard'
import { createLogger } from '@/common/logger'

const logger = createLogger({ prefix: 'EventPanel' })

// date format strings to use with format()
const MONTH_FORMAT = 'MMMM'
const DAY_FORMAT = 'd'
const MONTH_DAY_FORMAT = `${MONTH_FORMAT} ${DAY_FORMAT}`
const YEAR_FORMAT = 'yyyy'

export const EventPanel = ({ event }: HasEvent) => {
  const router = useRouter()
  const formatDate = () => {
    // helper method used to wrap a single date and returns function used to format with a provided template string
    const formatter = (dateObj) => {
      return (formatStr) => {
        return format(dateObj, formatStr)
      }
    }

    const { localStartDate, localEndDate } = event
    logger.log('formatDate', { localStartDate, localEndDate })

    if (!localStartDate) {
      return ''
    }
    if (!localEndDate) {
      return formatter(localStartDate)(`${MONTH_FORMAT} ${DAY_FORMAT}, ${YEAR_FORMAT}`)
    }

    const start = new Date(localStartDate)
    const end = new Date(localEndDate)

    const fS = formatter(start)
    const fE = formatter(end)
    const sameYear = start.getFullYear() === end.getFullYear()
    const sameMonth = start.getMonth() === end.getMonth()
    const sameDay = start.getDate() === end.getDate()

    let dateStr = ''

    if (!sameYear) {
      dateStr = `${fS(MONTH_DAY_FORMAT)}, ${fS(YEAR_FORMAT)} - ${fE(MONTH_DAY_FORMAT)}, ${fE(YEAR_FORMAT)}`
    } else if (sameMonth && sameDay) {
      dateStr = `${fS(MONTH_FORMAT)} ${fS(DAY_FORMAT)}`
    } else if (sameMonth) {
      dateStr = `${fS(MONTH_FORMAT)} ${fS(DAY_FORMAT)}-${fE(DAY_FORMAT)}`
    } else {
      dateStr = `${fS(MONTH_DAY_FORMAT)} - ${fE(MONTH_DAY_FORMAT)}`
    }
    if (sameYear) {
      dateStr += `, ${fS(YEAR_FORMAT)}`
    }
    logger.log('formatDate', dateStr)

    return dateStr
  }
  const getEventImage = () => {
    const url = event.imageUrl
    //TODO had copied in logix where -dev and -qa suffixes but this does not appear to be needed:
    //        i.e. image={(event.image_url || '').replace('-dev', '').replace('-qa', '')} 
    return (url || '')
  }


  return (
    <ChronoCard
      paper={{
        elevation: 0,
        backgroundColor: '#F3F3F3'
      }}
      image={{
        src: getEventImage(),
        title: event.name,
        link: `/event/${event.eventId}`
      }}
      content={
        <Box padding={1}>
          <Typography
            component={'h5'}
            variant={'h5'}
            className={'event-name'}
            data-cy={'event_header_name'}>

            {event.name}

          </Typography>

          <Typography
            variant={'subtitle2'}
            color={'textSecondary'}
            className={'event-details'}
            data-cy={'event_details'}>

            {formatDate()} | {event.hometown}

          </Typography>

        </Box>
      }
      controls={
        <Box display={'flex'} flexDirection={'row'} justifyContent={'end'}>
          <Button
            component={'a'}
            href={event.registerUrl}
            variant={'contained'}
            className={'event-register'}
            data-cy={'event_register'}>
            Register
          </Button>
        </Box>
      }
    />
  )
}